export default __webpack_public_path__ + "static/media/Lyrics.74dc968c.png";